var exports = {
  "kL": "KeybindsTab.module__container___ZkVYQz",
  "ft": "KeybindsTab.module__containerCompact___ZkVYQz",
  "Pc": "KeybindsTab.module__searchRow___ZkVYQz",
  "Vw": "KeybindsTab.module__customSection___ZkVYQz",
  "P_": "KeybindsTab.module__customHeader___ZkVYQz",
  "yy": "KeybindsTab.module__customHeaderText___ZkVYQz",
  "_U": "KeybindsTab.module__customTitle___ZkVYQz",
  "Mu": "KeybindsTab.module__customSubtitle___ZkVYQz",
  "DK": "KeybindsTab.module__shortcutOptions___ZkVYQz",
  "sC": "KeybindsTab.module__shortcutOption___ZkVYQz",
  "wm": "KeybindsTab.module__customList___ZkVYQz",
  "Kl": "KeybindsTab.module__customRow___ZkVYQz",
  "YI": "KeybindsTab.module__customRowDisabled___ZkVYQz",
  "Of": "KeybindsTab.module__customHeaderActions___ZkVYQz",
  "DN": "KeybindsTab.module__dotsButton___ZkVYQz",
  "D2": "KeybindsTab.module__customRowMain___ZkVYQz",
  "EG": "KeybindsTab.module__customField___ZkVYQz",
  "gF": "KeybindsTab.module__customFieldLabel___ZkVYQz",
  "Ou": "KeybindsTab.module__customControls___ZkVYQz",
  "dD": "KeybindsTab.module__customHint___ZkVYQz",
  "p$": "KeybindsTab.module__emptyState___ZkVYQz",
  "Z8": "KeybindsTab.module__conflictWarning___ZkVYQz",
  "se": "KeybindsTab.module__conflictIcon___ZkVYQz",
  "rs": "KeybindsTab.module__defaultsList___ZkVYQz",
  "WX": "KeybindsTab.module__defaultsSection___ZkVYQz",
  "Mz": "KeybindsTab.module__defaultsSectionTitle___ZkVYQz",
  "DC": "KeybindsTab.module__defaultsSectionRows___ZkVYQz",
  "Bq": "KeybindsTab.module__defaultChipsMerged___ZkVYQz",
  "r1": "KeybindsTab.module__defaultChips___ZkVYQz",
  "_R": "KeybindsTab.module__defaultRow___ZkVYQz",
  "pc": "KeybindsTab.module__defaultRowActions___ZkVYQz",
  "AB": "KeybindsTab.module__defaultLabel___ZkVYQz",
  "q3": "KeybindsTab.module__defaultChipsEmpty___ZkVYQz",
  "Oo": "KeybindsTab.module__defaultChip___ZkVYQz",
  "V": "KeybindsTab.module__permissionSectionHelper___ZkVYQz",
  "FG": "KeybindsTab.module__systemShortcutsCommands___ZkVYQz",
};

module.exports = exports;
